const groupPrefix = 'google-ratings'

export const apiGoogleRatings = {
	fetchGoogleRating: async () => {
		const { data } = await apiCommon<IGoogleRating>(`${groupPrefix}`, { method: 'GET', skipSSRPayload: true })
		return GoogleRatingFromJSON(data)
	},

	updateGoogleRating: async (ratingData: Partial<IGoogleRatingModel>) => {
		const { data } = await apiCommon<IGoogleRating>(`${groupPrefix}`, { method: 'PUT', body: GoogleRatingToJSON(ratingData) })
		return GoogleRatingFromJSON(data)
	},
}
